import React, { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useStyles } from './styles';

enum LoaderSizes {
  big = 100,
  small = 50,
}

interface CircularLoaderProps {
  size?: LoaderSizes;
  fullScreen?: boolean;
}

export const CircularLoader: FC<CircularLoaderProps> = ({
  size,
  fullScreen,
}) => {
  const classes = useStyles();
  return (
    <div className={`${classes.wrapper} ${fullScreen && classes.fullScreen}`}>
      <CircularProgress size={size || LoaderSizes.big} />
    </div>
  );
};
